module.exports = __webpack_public_path__ + "img/lamp.677d706e.svg";